import CustomTable from '../../../../../components/table/CustomTable';
import { permissionObj } from '../../../../../Helpers/permission';
import React from 'react';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import ScheduleHeader from './ScheduleHeader';
import AccessCodeTableApp from "../Functionality/AccessCodeTableApp";
import AddAccessCodeModal from "../Modal/AddAccessCodeModal";
import AccessCodeSummary from "../Modal/AccessCodeSummary";

/**
 * This component handles the display, creation, and summary view of access codes.
 * It integrates the main table, modals for adding and viewing details, and manages
 * selection, search, and pagination functionality.
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @param {Array} selectForDelete - List of currently selected items for deletion.
 * @param {Function} setSelectForDelete - Updates the selected items list for deletion.
 * @param {Array} selectForCancel - List of selected items for cancellation.
 * @param {Function} setSelectForCancel - Updates the selected items list for cancellation.
 * @param {boolean} isAllChecked - Flag indicating if the select all header checkbox is active.
 * @param {Function} setIsAllChecked - Updates the select all header checkbox state.
 * @param {boolean} modified - Flag indicating if data has been modified.
 * @param {Function} setModified - Updates the modified flag state.
 * @param {string} optionView - Current view option for the schedule header.
 * @param {Function} handleBtnShifts - Callback to handle shift button click.
 * @param {Function} handleBtnMeals - Callback to handle meals button click.
 * @param {Function} handleBtnAccessCode - Callback to handle access code button click.
 * @param {boolean} DEV - Flag for development mode, enabling extra functionality.
 * @param {Array|string[]} permission - List of current user permissions.
 * @param {string} option - Current table or module option used for API calls and data handling.
 *
 * @returns {JSX.Element} Renders the access code table, header, and modals.
 */
const AccessCodeTable = ({
                        selectForDelete,
                        setSelectForDelete,
                        selectForCancel,
                        setSelectForCancel,
                        isAllChecked,
                        setIsAllChecked,
                        modified,
                        setModified,
                        optionView,
                        handleBtnShifts,
                        handleBtnMeals,
                        handleBtnAccessCode,
                        DEV,
                        permission,
                        option
}) => {

    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        showAddModal,
        showSummaryModal,
        handleAddModalClose,
        handleSummaryModalClose,
        handleCreate,
        setBodyForExport,
        setResults,
        setSearchElement,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        searchElement,
        deletePermission,
        itemSelected
    } = AccessCodeTableApp({
        selectForDelete,
        setSelectForDelete,
        setSelectForCancel,
        setIsAllChecked,
        modified,
        setModified,
        option
    });

    return (<>

        <ScheduleHeader
            optionView={optionView}
            handleBtnShifts={handleBtnShifts}
            handleBtnMeals={handleBtnMeals}
            handleBtnAccessCode={handleBtnAccessCode}
            searchId={searchId}
            setBodyForExport={setBodyForExport}
            setSearchResults={setResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            option={option}
            page={page}
            rowsPerPage={rowsPerPage}
            setSimpleSearch={setSimpleSearch}
            search={search}
            setSearch={setSearch}
            DEV={DEV}
            permission={permission}
        />

        <CustomTable tableId={tableId}
                     searchId={searchId}
                     checkbox={deletePermission}
                     checkboxTitle={"de_/_select_all"}
                     isAllChecked={isAllChecked}
                     onChangeCheckbox={handleDeleteAll}
                     thead={thead}
                     tbody={tbody}
                     columnActions={deletePermission || DEV || permission?.includes(permissionObj?.WEB_FOODIE_ACCESS_CANCEL)}
                     getActionsButtons={getActionsButtons}
                     handleCheckboxChange={handleCheckboxChange}
                     selectedList={selectForDelete}
                     childrenNotInformation={tbody?.data?.length === 0 ? <>
                             <div className={"warning-text"}>
                                {!searchElement && (
                                 <p>{t("you_haven_not_created_any_access_code")}</p>
                                )}
                             </div>
                             { (DEV || permission?.includes(permissionObj?.WEB_FOODIE_ACCESS_CREATE)) &&
                             <CustomButtonLink splitName={false} id={'btn_ac_create'} card={true}
                                               onClick={handleCreate}
                                               name={'add_new_access'}/>
                             } </>
                         : undefined
                     }
        />
        {pagination()}

        {showAddModal &&
            <AddAccessCodeModal
                show={showAddModal}
                onHide={() => { handleAddModalClose() }}
                setModified={setModified}
            />
        }

        {showSummaryModal && itemSelected?.item?.id &&
        <AccessCodeSummary
            show={showSummaryModal}
            onHide={() => { handleSummaryModalClose() }}
            item={itemSelected?.item}
        />
        }

    </>)
}
export default AccessCodeTable;
